import { Component, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { GlobalVariables } from '../../../common';

@Component({
  selector: 'monitor-video',
  template: `<iframe *ngIf="src" [src]="src" frameborder="0" allowfullscreen></iframe>`,
})
export class MonitorVideoComponent implements OnChanges {
  @Input() attachments: string[] = [];
  @Input() mediaId: string = '';

  src: SafeResourceUrl = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges() {
    const videoUrl = this.attachments?.[0];
    if (!videoUrl) {
      this.src = '';
      return;
    }

    const videoOptions = Object.fromEntries(
      Object.entries(GlobalVariables.VIDEO_URL_OPTIONS).map(([key, value]) => [key, String(value)]),
    );
    const params = new URLSearchParams({ ...videoOptions, playlist: this.mediaId });
    this.src = this.sanitizer.bypassSecurityTrustResourceUrl(`${videoUrl}?${params.toString()}`);
  }
}
